import { Box } from "@mui/material"

export const PageNotFound = () => {
    return (<Box sx={{ margin: '50px', height: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center' }}>
        <h1>404 Page not found</h1>
    </Box>)
}